import { translate } from '../../i18n/index.js';
import { useEffect, useRef, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { authApi } from '../../api/auth.api.js';
import { useAuthStore } from '../../store/auth.store.js';

export function MagicLinkVerify() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setTokens, setAccount, setRole, setTenantSlug, setAvailableTenants } = useAuthStore();
  const [error, setError] = useState<string | null>(null);
  const didVerify = useRef(false);

  useEffect(() => {
    if (didVerify.current) return;
    didVerify.current = true;

    const token = searchParams.get('token');
    if (!token) {
      setError(translate('pages.public.magic_link_verify.magic_link_verify.set_error.copy'));
      return;
    }
    const redirectTo = getSafeRedirect(searchParams.get('redirect'));

    authApi
      .verifyMagicLink(token)
      .then((res) => {
        setTokens(res.data.accessToken, res.data.refreshToken);
        setAccount(res.data.account);
        setRole(res.data.role);
        setTenantSlug(res.data.tenant?.slug ?? null);
        setAvailableTenants(res.data.availableTenants);
        const destination =
          redirectTo && redirectTo !== '/auth/create-password'
            ? redirectTo
            : res.data.role
              ? '/admin'
              : '/gyms';
        if (res.data.requiresPasswordSetup) {
          void navigate(`/auth/create-password?redirect=${encodeURIComponent(destination)}`, {
            replace: true,
          });
          return;
        }
        void navigate(destination, { replace: true });
      })
      .catch(() =>
        setError(translate('pages.public.magic_link_verify.magic_link_verify.set_error.validity')),
      );
  }, []);

  if (error) return <p style={{ fontFamily: 'sans-serif', color: 'red', margin: 40 }}>{error}</p>;
  return (
    <p style={{ fontFamily: 'sans-serif', margin: 40 }}>
      {translate('pages.public.magic_link_verify.magic_link_verify.p.description')}
    </p>
  );
}

function getSafeRedirect(value: string | null) {
  if (!value?.startsWith('/')) return null;
  if (value.startsWith('//')) return null;
  return value;
}
